// Module
var code = `<div class="HOA-misc-guidedSteps__flex HOA-misc-guidedSteps__flex-padded HOA-misc-guidedSteps__flex-align-center">
    <div class="HOA-misc-guidedSteps__flex-child HOA-make-guidedSteps_label--padding">
        <label tid="emailAddressLabel" id="emailAddressLabel" for="emailaddress" class="u-fontBold">
            Email Address
            <span *ngIf="personalInfoData.showRequired" class="asterisk-required">&nbsp;&#42;</span>
            <!-- show when looking up email (ng-if does not work for spinners) -->
            <span [style.visibility]="personalInfoData.isValidatingEmail ? 'visible' : 'hidden'" class="u-mL4">
                        <span class="Loader Loader--sm Loader--blue"></span>
                    </span>
        </label>
    </div>
    <div *ngIf="showEasyEmailAddressInput"
         [ngClass]="{ 'is-invalid': personalInfoData.emailAddressError }" class="Field HOA-misc-guidedSteps__flex-child">
        <input type="email"
               (blur)="emailLookup()"
               class="Input"
               id="emailaddressInput"
               tid="emailaddressInput"
               maxlength="100"
               [(ngModel)]="emailValue"
               required
               aria-invalid="emailAddressError"
               attr.aria-describedby="{{personalInfoData.emailAddressError && 'emailaddress-error' || undefined }}">
        <span class="Field-error" tid="emailaddress-error"
              id="emailaddress-error">{{personalInfoData.emailAddressErrorMessage}}</span>
    </div>
    <div *ngIf="!showEasyEmailAddressInput" class="Field HOA-misc-guidedSteps__flex-child">
        <span tid="emailaddress" id="emailaddress">{{personalInfoData.homeowner.contactInformation.email.value}}</span>
    </div>
</div>`;
// Exports
module.exports = code;